/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Board from 'react-trello';
import { message } from 'antd/lib';
import DriversAllocationCard from './components/DriversAllocationCard';
import FilterBar from '$app/shared/components/FilterBar';
import DateRangeFilter from '$app/shared/components/DateRangeFilter';
import SegmentFilter from '$app/shared/components/SegmentFilter';
import GarageFilter from '$app/shared/components/GarageFilter';
import DriverFilter from '$app/shared/components/DriverFilter';
import { getColumnsWithBookings } from './columnLogic';
import { momentArray } from '../../common/helpers';
import { saveFiltersInLocalStorage, getSavedFiltersFromLocalStorage } from '../../../common/helpers';

const DriversAllocation = ({ bookings, garages, drivers, earliestBookingDate }) => {
  const savedFilters = getSavedFiltersFromLocalStorage('driverAllocationFilters');

  // Filters selected by case managers
  const [filteredSegment, setFilteredSegment] = useState(savedFilters.segment);
  const [filteredDateRange, setFilteredDateRange] = useState(savedFilters.dateRange);
  const [filteredGarage, setFilteredGarage] = useState(savedFilters.garage);
  const [filteredDriver, setFilteredDriver] = useState(savedFilters.driver);

  useEffect(
    () =>
      saveFiltersInLocalStorage('driverAllocationFilters', {
        segment: filteredSegment,
        dateRange: filteredDateRange,
        garage: filteredGarage,
        driver: filteredDriver,
      }),
    [filteredSegment, filteredDateRange, filteredGarage, filteredDriver]
  );

  const clearAllFilters = () => {
    setFilteredSegment(null);
    setFilteredDateRange(null);
    setFilteredGarage('');
    setFilteredDriver('');
    localStorage.removeItem('driverAllocationFilters');
    message.success('Cleared all filters');
  };

  const userSelectedFilters = {
    filteredDateRange,
    filteredGarage,
    filteredSegment,
    filteredDriver,
  };

  const columnsWithBookings = getColumnsWithBookings(
    bookings?.bookingToAllocateDriver || [],
    userSelectedFilters
  );

  return (
    <div className="allocation-page drivers">
      <FilterBar
        mainFilters={
          <>
            <SegmentFilter onChange={setFilteredSegment} value={filteredSegment} />
            <DateRangeFilter
              onChange={setFilteredDateRange}
              value={momentArray(filteredDateRange)}
              earliestSelectableDate={earliestBookingDate}
            />
            <GarageFilter onSelect={setFilteredGarage} value={filteredGarage} garages={garages} />
            <DriverFilter onSelect={setFilteredDriver} value={filteredDriver} drivers={drivers} />
          </>
        }
        onClearFilters={clearAllFilters}
      />
      <div className="allocation-grid">
        <Board
          data={{ lanes: columnsWithBookings }}
          components={{
            Card: DriversAllocationCard,
          }}
        />
      </div>
    </div>
  );
};

export default DriversAllocation;
